// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CenterAuthStructure_wrapper__tlf0W","auth-wrapper":"CenterAuthStructure_auth-wrapper__2JiUb"};